import { useTranslation } from "react-i18next";
import CheckUserStatusForm from "./CheckUserStatus.form";
import DynamicForm from "../../../../../yoello-lib/modules/dynamicForms/DynamicForms";
import useCheckUserStatus from "./useCheckUserStatus";
import EColourPanel from "../../../../../interfaces/EColourPanel";
import { IDialogChildComponent } from "../../../../../reducers/dialog";
import { Box } from "@material-ui/core";
import { useStyles } from "./ui/style";
import { UserStatusEnum } from "./type";

const CheckUserStatus = ({ onClose }: IDialogChildComponent) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    isLoading,
    userStatus,
    CreatedOn,
    error,
    onSubmit,
    onSetNewPassword,
    onClear,
    onSearch,
  } = useCheckUserStatus(onClose);

  return (
    <Box className={classes.userStatusContainer}>
      <DynamicForm
        onHandleSubmit={onSubmit}
        formRows={CheckUserStatusForm(
          t,
          isLoading,
          userStatus,
          CreatedOn,
          error,
          onSearch,
          onClear
        )}
        formKeyName="check-user-status"
        useFormOptions={{
          reValidateMode: "onSubmit",
        }}
        isDialog={true}
        formButtons={{
          leftButton: {
            type: "button",
            label: t("forms.buttons.cancel"),
            color: EColourPanel.DEFAULT,
            fullWidth: false,
            onClick: onClose,
          },
          rightButton: {
            type: "submit",
            label: t("checkUserStatus.buttons.setNewPassword"),
            color: EColourPanel.PRIMARY,
            fullWidth: false,
            onClick: onSetNewPassword,
            disabled:
              isLoading || userStatus !== UserStatusEnum.FORCE_CHANGE_PASSWORD,
          },
        }}
      />
    </Box>
  );
};

export default CheckUserStatus;
